export default "__VITE_ASSET__e0ee2e31__"